import { defineMessages } from "react-intl";

const baseId = "t.pages.TasksRequestList.";

export default defineMessages({
  takeCharge: {
    id: baseId + "takeCharge",
    defaultMessage: "Take charge",
  },
  untakeCharge: {
    id: baseId + "untakeCharge",
    defaultMessage: "Cancel Take charge",
  },
  alreadyCharge: {
    id: baseId + "alreadyCharge",
    defaultMessage: "Already in charge",
  },
  cantTakeChargeMsg: {
    id: baseId + "cantTakeChargeMsg",
    defaultMessage: "Il tuo ruolo non è abilitato a prendere in carico il task",
  },
  emptyTable: {
    id: baseId + "emptyTable",
    defaultMessage: "Nessun risultato trovato",
  },
  unauthTaskViewer: {
    id: baseId + "unauthTaskViewer",
    defaultMessage: "You are not authorized to view tasks",
  },

  IN_EXECUTION: {
    id: baseId + "IN_EXECUTION",
    defaultMessage: "IN EXECUTION",
  },
  NOT_ASSIGNED: {
    id: baseId + "NOT_ASSIGNED",
    defaultMessage: "NOT ASSIGNED",
  },
  TAKING_CHARGE: {
    id: baseId + "TAKING_CHARGE",
    defaultMessage: "TAKING CHARGE",
  },

  CTAExit: {
    id: baseId + "CTAExit",
    defaultMessage: "Exit",
  },
});
